import { createAsyncThunk } from "@reduxjs/toolkit";

import { getStatus } from "Api/organizations/mfa-enforcement/getStatus.request";

export const getEnforceMFAStatusThunk = createAsyncThunk(
  "enforceMFA/getStatus",
  getStatus
);
